var _path, _path2, _mask, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 448,
    viewBox: "0 0 476 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.835 242.529L187.64 316.773C174.076 322.869 158.738 312.947 158.737 298.076L158.726 149.611C158.725 134.74 174.062 124.816 187.628 130.91L352.833 205.131C368.963 212.378 368.965 235.28 352.835 242.529Z",
    fill: "#9BC53D",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.356 319.73L163.046 310.93L365.855 220.779L360.764 237.708L179.356 319.73Z",
    fill: "black",
    fillOpacity: 0.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_331_165",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.882 219.509L159.883 246.225L40.0237 246.233L40.0218 219.517L159.882 219.509Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.882 219.509L159.883 246.225L40.0237 246.233L40.0218 219.517L159.882 219.509Z",
    fill: "#9BC53D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.882 219.509L163.882 219.509L163.881 215.509L159.881 215.509L159.882 219.509ZM159.883 246.225L159.884 250.225L163.884 250.225L163.883 246.225L159.883 246.225ZM155.882 219.51L155.883 246.225L163.883 246.225L163.882 219.509L155.882 219.51ZM159.883 242.225L40.0234 242.233L40.0239 250.233L159.884 250.225L159.883 242.225ZM40.0221 223.517L159.882 223.509L159.881 215.509L40.0216 215.517L40.0221 223.517Z",
    fill: "black",
    mask: "url(#path-3-inside-1_331_165)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/Leaf.a4e7eccfba8f1affd333f6e57f996caa.svg";
export { ForwardRef as ReactComponent };